import { Flex, Textarea, Tag, TagLabel } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import useRiskScore from "../../../../hooks/useRiskScore";

const OnboardingStep42 = ({ handleChange }) => {
  const { overallScore, getScoreColor } = useRiskScore();

  

  return (
    <>
      <Flex direction="column" gap={8}>
        <h6>Risk conclusion</h6>
        <Flex direction="column">
          <Fieldset
            label="Overall risk rating"
            description="Average risk rating"
            input={
              <Tag
                size="lg"
                variant="solid"
                colorScheme={getScoreColor(overallScore)}
              >
                <TagLabel>{overallScore}</TagLabel>
              </Tag>
            }
          />

          <Fieldset
            label="Required controls"
            description="Specify the required controls for the fund"
            input={
              <Textarea
                name="requiredControls"
                placeholder="Enter required controls"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Monitoring requirements"
            description="Specify the monitoring requirements for the fund"
            input={
              <Textarea
                name="monitoringRequirements"
                placeholder="Enter monitoring requirements"
                onChange={handleChange}
              />
            }
          />
        </Flex>
      </Flex>
    </>
  );
};

export default OnboardingStep42;
